import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ILocationContext } from '../../../model/location-context';
import { IStatistic } from '../../../model/statistics';
import StatisticsActions from './store/statistics.action-types';
import { StatisticsState } from './store/statistics.reducers';
import { statisticsSelector } from './store/statistics.selectors';

@Injectable({
    providedIn: 'root'
})
export class StatisticsService {
    constructor(private readonly store: Store<StatisticsState>) {}

    requestStatistics(locationContext: ILocationContext) {
        this.store.dispatch(StatisticsActions.requestStatistics({ locationContext }));
    }

    loadStatistics(statistics: IStatistic[]) {
        this.store.dispatch(StatisticsActions.loadStatistics({ statistics }));
    }

    getStatistics(): Observable<IStatistic[]> {
        return this.store.select(statisticsSelector);
    }
}
